import Api from '../api'
export default ({

  state: {
    poolTypeList: [],
    faItemGroupList: [],
    fixedAssetsItemMasterList: []
  },
  mutations: {
    SET_POOL_LIST(state, response) {
      state.poolTypeList = response
    },
    CREATE_FA_ITEMGROUP(state, itemGroup) {
      let FAItemGroup = state.faItemGroupList.concat(itemGroup)
      state.faItemGroupList = FAItemGroup
    },
    FIXEDASSETS_ITEMMASTER_LIST (state, fixedAssetsItemMaster) {
      state.fixedAssetsItemMasterList = fixedAssetsItemMaster
    }
  },
  actions: {
    async loadPoolTypeList({commit}) {
      let response = await Api.request('get', '/fixedAssets/fixedAssetsPoolList/' + this.state.organisationid)
      if (response.data.status === 'SUCCESS') {
        commit('SET_POOL_LIST', response.data.data)
      }
    },
    async createFaItemGroup({commit}, itemGroup) {
      let response = await Api.request('post', '/itemGroup/' + this.state.organisationid + '/' + this.getters.userId, itemGroup)
      if (response.data.status === 'SUCCESS') {
        commit('CREATE_FA_ITEMGROUP', response.data.data)
      }
      return response
    },
    async loadFixedAssetsItemMasterList({commit}) {
      let response = await Api.request('get', '/fixedAssetsItem/' + this.state.organisationid + '/' + this.state.fyId + '/' + this.state.warehouseData.id, null)
      commit('SETITEMMASTERLISTBYITEMTYPE', response.data.data)
    }
  },
  getters: {
  }
})



// WEBPACK FOOTER //
// ./src/store/fixedAssets.js